// src/components/OrganizationManagement/OrganizationTable.js
import React from 'react';
import PropTypes from 'prop-types';
import OrganizationTableRow from './OrganizationTableRow';
import './OrganizationTable.css';

/**
 * OrganizationTable component for displaying the organizations table
 * Handles filtering, sorting, and rendering of organization rows
 */
const OrganizationTable = ({
  organizations,
  searchTerm,
  currentOrganizationId,
  loading,
  copiedOrgId,
  userProfile,
  onSwitchOrganization,
  onViewUsers,
  onCopyOrgId,
  onOpenInstallationManagement,
  onEdit,
  onAuthorize,
  onUnauthorize,
  onDelete,
  formatDate,
}) => {
  // Filter organizations by search term
  const filteredOrgs = organizations.filter((org) => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return (
      org.name.toLowerCase().includes(search) ||
      org.orgId.toLowerCase().includes(search)
    );
  });

  // Sort organizations alphabetically by name
  const sortedOrgs = [...filteredOrgs].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="organizations-table-container">
      <table className="organizations-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Users</th>
            <th>Organization ID</th>
            <th>Sites</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedOrgs.map((organization) => {
            const isCurrent = organization.orgId === currentOrganizationId;

            return (
              <OrganizationTableRow
                key={organization.orgId}
                organization={organization}
                isCurrent={isCurrent}
                loading={loading}
                copiedOrgId={copiedOrgId}
                userProfile={userProfile}
                onSwitchOrganization={onSwitchOrganization}
                onViewUsers={onViewUsers}
                onCopyOrgId={onCopyOrgId}
                onOpenInstallationManagement={onOpenInstallationManagement}
                onEdit={onEdit}
                onAuthorize={onAuthorize}
                onUnauthorize={onUnauthorize}
                onDelete={onDelete}
                formatDate={formatDate}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

OrganizationTable.propTypes = {
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      orgId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      romanworksAuthzStatus: PropTypes.string,
      installations: PropTypes.array,
      createdAt: PropTypes.string,
    })
  ).isRequired,
  searchTerm: PropTypes.string,
  currentOrganizationId: PropTypes.string,
  loading: PropTypes.bool,
  copiedOrgId: PropTypes.string,
  userProfile: PropTypes.shape({
    roles: PropTypes.arrayOf(PropTypes.string),
  }),
  onSwitchOrganization: PropTypes.func,
  onViewUsers: PropTypes.func.isRequired,
  onCopyOrgId: PropTypes.func.isRequired,
  onOpenInstallationManagement: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
  onAuthorize: PropTypes.func.isRequired,
  onUnauthorize: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
};

OrganizationTable.defaultProps = {
  searchTerm: '',
  currentOrganizationId: null,
  loading: false,
  copiedOrgId: null,
  userProfile: null,
  onSwitchOrganization: null,
  onOpenInstallationManagement: null,
};

export default OrganizationTable;
